import AnalyticsComponent from "./analytics.component";
import AnalyticsDetailComponent from "./analytics-detail/analytics-detail.component";
import Router from "./analytics-router";

export const AnalyticsModule = angular
    .module("analytics", [])
    .component("analytics", AnalyticsComponent)
    .component("analyticsDetail", AnalyticsDetailComponent)
    .config(Router);



// WEBPACK FOOTER //
// ./sources/components/analytics/analytics.js